// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".turn-server{height:44px;display:flex;align-items:center}.icon{display:inline-block;width:44px;height:44px;vertical-align:middle}\n", ""]);
// Exports
module.exports = exports;
